import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth-guard-service.service';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: './home/home.module#HomePageModule' },

  //DESCOMENTAR LOS QUE ESTAN COMENTADOS PARA ACTIVAR LA PROTECCION DE RUTAS

  { path: 'menu', loadChildren: './menu/menu.module#MenuPageModule', canActivate: [AuthGuardService] },
  { path: 'pedidos', loadChildren: './pedidos/pedidos.module#PedidosPageModule',canActivate: [AuthGuardService] },
  { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardPageModule',canActivate: [AuthGuardService] },
  { path: 'solicitud', loadChildren: './solicitud/solicitud.module#SolicitudPageModule',canActivate: [AuthGuardService] },
  { path: 'calificacion', loadChildren: './calificacion/calificacion.module#CalificacionPageModule',canActivate: [AuthGuardService] },
  { path: 'reporte', loadChildren: './reporte/reporte.module#ReportePageModule',canActivate: [AuthGuardService] },
  { path: 'signup', loadChildren: './signup/signup.module#SignupPageModule'},
  { path: 'modal-editar-afes', loadChildren: './modal-editar-afes/modal-editar-afes.module#ModalEditarAfesPageModule' },
  
  // { path: 'modal-afes-multiples', loadChildren: './modal-afes-multiples/modal-afes-multiples.module#ModalAfesMultiplesPageModule' },
 
  
  
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
